import { values } from "lodash";
import type { SongId, Songs } from "./types";

interface Args {
  songs: Songs;
  title: string;
  artist: string;
  ignoreSongIds?: SongId[];
}

export default function findSongs(arg: Args) {
  const ignoreSongIds = arg.ignoreSongIds || [];
  return values(arg.songs).filter(({ id, title, artist }) => {
    if (
      arg.title.toLowerCase() === title.toLowerCase() &&
      arg.artist.toLowerCase() === artist.toLowerCase() &&
      !ignoreSongIds.includes(id)
    ) {
      return true;
    }
    return false;
  });
}
